export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5366.00c1b854.jpg";